module.exports = __webpack_public_path__ + "img/propertysystem3.57af9ac5.png";